exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2DEi_y3eEhbi0SOPRzfamt .ms-DatePicker-event--without-label,._2DEi_y3eEhbi0SOPRzfamt input{color:\"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir] ._3h_z-FXHgl6z-HmASw2QCI .ms-TextField-fieldGroup{background-color:transparent}", ""]);
// Exports
exports.locals = {
	"grey": "_2DEi_y3eEhbi0SOPRzfamt",
	"datepickerInput": "_3h_z-FXHgl6z-HmASw2QCI"
};